<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">

            <el-form-item label="轮询名称：">
                <el-input v-model.trim="searchForm.name" @keyup.enter.native="getListHandler" placeholder="请输入轮询名称"
                    clearable></el-input>
            </el-form-item>

            <el-form-item label="轮询状态：">
                <el-select v-model="searchForm.lunState" clearable>
                    <el-option label="执行中" value="1"></el-option>
                    <el-option label="执行完成" value="2"></el-option>
                    <el-option label="执行失败" value="3"></el-option>
                </el-select>
            </el-form-item>


            <el-form-item label="开始时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-row>
            <el-button type="danger" plain @click="showSimManage(1)">执行没有次月套餐停机</el-button>
            <el-button type="primary" icon="el-icon-edit" plain @click="showSimManage(2)">执行有可用套餐复机</el-button>
        </el-row>
        <el-table :data="tbpg.tableData" style="width:100%;margin-top: 20px;" border fit highlight-current-row
            :header-cell-style="{ background: '#f5f5f5' }" :default-sort="{ prop: 'rpTime', order: 'descending' }">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <!-- <el-table-column prop="id" label="轮训序号" align="center"></el-table-column> -->
            <el-table-column prop="taskName" label="轮训名称" width="250" align="center"></el-table-column>
            <el-table-column prop="threadSize" label="轮询线程数" align="center"></el-table-column>
            <el-table-column prop="sleepTime" label="轮询间隔时间" align="center"></el-table-column>
            <el-table-column prop="totalNum" label="SIM轮训总数" align="center"></el-table-column>
            <el-table-column prop="successNum" label="SIM成功总数" align="center"></el-table-column>
            <el-table-column label="SIM失败总数" align="center">
                <el-tooltip slot-scope="scope" content="点击查询失败详情">
                    <a href="javascript:void(0);" @click="goToInfoFailPage(scope.row.id, $event)"
                        style="color:red;font-size:18">{{ scope.row.failNum }}</a>
                </el-tooltip>
            </el-table-column>
            <el-table-column prop="remainSim" label="SIM剩余总数" align="center"></el-table-column>
            <el-table-column prop="createTime" label="轮训开始时间" align="center"></el-table-column>
            <el-table-column prop="endTime" label="轮训结束时间" align="center"></el-table-column>
            <el-table-column label="备注" align="center">
                <el-tooltip slot-scope="scope" :content="scope.row.msg">
                    <p> {{ scope.row.msg }}</p>
                </el-tooltip>
            </el-table-column>
            <el-table-column label="操作" align="center" width="220">
                <template slot-scope="scope">
                    <el-button @click="excelData(scope.row.id)" v-if="scope.row.failNum > 0 && scope.row.endTime" type="text"
                        size="small">导出失败卡</el-button>
                    <el-button @click="showEditDialog(scope.row.id)" v-if="scope.row.failNum > 0 && scope.row.endTime"
                        type="text" size="small">重轮失败卡</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" title="失败记录" :visible.sync="failVisible" width="1000px"
            :close-on-click-modal="false" @close="cancel">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column prop="remark" label="失败原因"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage" :page-sizes="[10, 50, 100, 5000]" :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>







        <el-dialog :append-to-body="true" :title="textRemark" :visible.sync="editVisibale" width="600px"
            class="notifyDetail" :close-on-click-modal="false" @close="cancel()">
            <el-form ref="editForm" :model="editForm" label-width="140px">

                <el-form-item label="选择套餐系列：" rop="supplierCodes">
                    <el-select v-model="editForm.supplierCodes" multiple filterable placeholder="请选择" style="width: 80%;">
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                    <el-button
                        @click="editForm.supplierCodes.length == branchSupplierOption.length ? cancelChooseAll() : chooseAll()"
                        style="width: 18%; float: right;">
                        {{ editForm.supplierCodes.length == branchSupplierOption.length ? "取消全选" : "全 选" }}
                    </el-button>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="confirmHandler()">确 定</el-button>
            </div>
        </el-dialog>





    </div>
</template>
<script>
import common from '@/utils/common.js'
import { getBgdRechargeList, getBgdRechargeFailLists, getPkgListOfGroup } from '@/api/sim.js'
export default {
    data() {
        return {
            textRemark: '无次月停机',
            editVisibale: false,
            editForm: {
                type: "",
                supplierNames: '',
                supplierCodes: [],
            },
            branchSupplierOption: [],



            searchForm: {
                lunState: '',
                name: '',
                time: ''
            },

            //订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            currentId_fail: '',
            failVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    methods: {
        confirmHandler() {
            var d = {
                ...this.editForm
            }
            d.supplierCodes = d.supplierCodes.join("，");
            let path = "lunxun/manage/state";
            common.sysRequest(path, d, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.cancel();
                    this.getListPageHandle();

                } else {
                    this.$message.error(res.data.message);
                }
            })

        },
        showSimManage(type) {
            if (type == 2) {
                this.textRemark = '有可用套餐复机'
            } else {
                this.textRemark = '无次月停机';
            }
            this.editForm.type = type;
            this.editVisibale = true;
        },

        chooseAll() {
            let val = [];
            for (let i in this.branchSupplierOption) {
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll() {
            this.editForm.supplierCodes = [];
        },

        excelData(id) {
            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('export/lunxunFail', {id:id}, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            }).catch(() => {
            });
        },

        showEditDialog(id) {
            this.$confirm("重试即代表重新轮询。 确定要执行失败卡轮询吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    id: id
                }
                common.sysRequest('lunxun/reload/fail/sim', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getListPageHandle();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }

                })
            })



        },
        cancel() {
            this.editForm = {
                type: "",
                supplierCodes: [],
            }
            this.editVisibale = false;
            this.failVisible = false;
        },
        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('lunxun/select/all/task/info', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.pageSize = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.pageSize = val
                this.getListPageHandle();
            }
        },
        //失败列表
        goToInfoFailPage(id, $event) {
            this.failVisible = true;
            this.currentId_fail = id;
            var data = {
                'id': id
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', data);
            common.sysRequest('lunxun/select/all/task/info/fail', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg_fail');

            })

        },
        handleCurrentChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val
                this.getListPageHandle();
            }
        },
        //执行sim卡轮训
        lunXunSimTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '如果有轮训尚未结束，请勿重复执行轮训！确定要手动执行SIM卡轮训吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.getListPageHandle();
                                this.$message.success(res.data.message);
                                done();
                            } else {
                                this.$message.error(res.data.message);
                                done();
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })


        },
        //执行代理商统计
        lunXunAgentTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行代理商统计吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/agentCount', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunPauseTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行没有次月套餐停机吗？此操作请谨慎操作！')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/pause/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunActiveTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行有有效套餐复机吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/active/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        //重新购买
        buyPkgReload(rowData) {
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo: rowData.downOrder,
                isNextMonth: rowData.isNextMonth,
                packgeId: rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/reload', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        }


    },

    created() {
        common.getPkgGroupListCom(this, 'branchSupplierOption');
        this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;;
        this.getListPageHandle();
    },
    mounted() {
        this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;
    },
    computed: {
        fluxPollDetailIccid: function () {
            return this.$store.state.menu.fluxPollDetailIccid;;
        },

    },

    watch: {
        fluxPollDetailIccid: function () {
            this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;;
            this.getListPageHandle();
        },
    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }

    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

